import { Injectable, InjectionToken, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { take, switchMap, catchError } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class JsonLoaderService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.jsonDataSubject = new ReplaySubject(1);
        this.jsonData = this.jsonDataSubject.asObservable();
        this.originalJsonData = {};
        this.loadJson = (/**
         * @param {?} path
         * @return {?}
         */
        (path) => {
            this.http.get(path).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.originalJsonData = data;
                this.jsonDataSubject.next(data);
            }));
        });
        this.updateConfig = (/**
         * @param {?} config
         * @return {?}
         */
        (config) => {
            this.jsonDataSubject.next(config);
        });
        this.restoreConfig = (/**
         * @return {?}
         */
        () => {
            this.jsonDataSubject.next(this.originalJsonData);
        });
    }
}
JsonLoaderService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
JsonLoaderService.ctorParameters = () => [
    { type: HttpClient }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    JsonLoaderService.prototype.jsonDataSubject;
    /**
     * @type {?}
     * @protected
     */
    JsonLoaderService.prototype.jsonData;
    /**
     * @type {?}
     * @private
     */
    JsonLoaderService.prototype.originalJsonData;
    /**
     * @type {?}
     * @protected
     */
    JsonLoaderService.prototype.loadJson;
    /**
     * @type {?}
     * @protected
     */
    JsonLoaderService.prototype.updateConfig;
    /** @type {?} */
    JsonLoaderService.prototype.restoreConfig;
    /**
     * @type {?}
     * @private
     */
    JsonLoaderService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CONFIGURATION_FILE_PATH = new InjectionToken('configuration-file-path');
/**
 * @template T
 */
class ConfigService extends JsonLoaderService {
    /**
     * @param {?} http
     * @param {?} configurationFilePath
     */
    constructor(http, configurationFilePath) {
        super(http);
        this.loadJson(configurationFilePath);
        this.currentConfiguration = this.jsonData;
    }
}
ConfigService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ConfigService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: [CONFIGURATION_FILE_PATH,] }] }
];
if (false) {
    /** @type {?} */
    ConfigService.prototype.currentConfiguration;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class ApiService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.handleErrors = (/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            throw error;
        });
        this.get = (/**
         * @template T
         * @param {?} path
         * @param {?=} headers
         * @return {?}
         */
        (path, headers) => {
            return this.apiBaseUri.pipe(take(1), switchMap((/**
             * @param {?} apiBaseUri
             * @return {?}
             */
            apiBaseUri => {
                return this.httpClient.get(`${apiBaseUri}${path}`, { headers: headers })
                    .pipe(catchError(this.handleErrors));
            })));
        });
        this.post = (/**
         * @template T
         * @param {?} path
         * @param {?} data
         * @param {?=} headers
         * @return {?}
         */
        (path, data, headers) => {
            return this.apiBaseUri.pipe(take(1), switchMap((/**
             * @param {?} apiBaseUri
             * @return {?}
             */
            apiBaseUri => {
                return this.httpClient.post(`${apiBaseUri}${path}`, data, { headers: headers })
                    .pipe(catchError(this.handleErrors));
            })));
        });
        this.put = (/**
         * @template T
         * @param {?} path
         * @param {?} data
         * @param {?=} headers
         * @return {?}
         */
        (path, data, headers) => {
            return this.apiBaseUri.pipe(take(1), switchMap((/**
             * @param {?} apiBaseUri
             * @return {?}
             */
            apiBaseUri => {
                return this.httpClient.put(`${apiBaseUri}${path}`, data, { headers: headers })
                    .pipe(catchError(this.handleErrors));
            })));
        });
        this.delete = (/**
         * @param {?} path
         * @param {?=} headers
         * @return {?}
         */
        (path, headers) => {
            return this.apiBaseUri.pipe(take(1), switchMap((/**
             * @param {?} apiBaseUri
             * @return {?}
             */
            apiBaseUri => {
                return this.httpClient.delete(`${apiBaseUri}${path}`, { headers: headers })
                    .pipe(catchError(this.handleErrors));
            })));
        });
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ApiService.prototype.handleErrors;
    /**
     * @type {?}
     * @protected
     */
    ApiService.prototype.get;
    /**
     * @type {?}
     * @protected
     */
    ApiService.prototype.post;
    /**
     * @type {?}
     * @protected
     */
    ApiService.prototype.put;
    /**
     * @type {?}
     * @protected
     */
    ApiService.prototype.delete;
    /**
     * @type {?}
     * @private
     */
    ApiService.prototype.httpClient;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    ApiService.prototype.apiBaseUri = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VisibilityService {
    constructor() {
        this._isVisible = new BehaviorSubject(false);
        this.toggleVisibility = (/**
         * @return {?}
         */
        () => {
            this._isVisible.next(!this._isVisible.value);
        });
        this.setVisibility = (/**
         * @param {?} visible
         * @return {?}
         */
        (visible) => {
            this._isVisible.next(visible);
        });
    }
    /**
     * @return {?}
     */
    get isVisible() {
        return this._isVisible.asObservable();
    }
    /**
     * @return {?}
     */
    get isVisibleSync() {
        return this._isVisible.value;
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    VisibilityService.prototype._isVisible;
    /** @type {?} */
    VisibilityService.prototype.toggleVisibility;
    /** @type {?} */
    VisibilityService.prototype.setVisibility;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ApiService, CONFIGURATION_FILE_PATH, ConfigService, JsonLoaderService, VisibilityService };
//# sourceMappingURL=shaman-utils.js.map
